import { graphql } from '@search/gql-client/src';

export const OfferPhoneQuery = graphql`query OfferPhoneQuery($offerId: ID!, $isCard: Boolean) {
    offerPhone(offerId: $offerId, isCard: $isCard) {
        phone {
            href
            isDoppelganger
            isReplaceable
            formattedNumber
            countryCode
            number
        }
    }
}`;
